module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"components":{"users":{"profile":{"empty_state":{"action":"Zum Tool-Tipp","empty_state":"Haben Sie Ihr Profil bereits fertig gestellt?<br/>Ergänzen Sie Ihr Profil für mehr Vertrauenswürdigkeit und lassen Sie es verifizieren, um neue Funktionen freizuschalten.<br/>Mehr dazu erfahren Sie in diesem Tool-Tipp.","title":"Dieses Mitglied hat sich noch nicht vorgestellt."}}}}}}}')
  delete Component.options._Ctor
}
